import { render, staticRenderFns } from "./VariantNew.vue?vue&type=template&id=d9c95888&"
import script from "./VariantNew.vue?vue&type=script&lang=js&"
export * from "./VariantNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports